<template>
  <div class="stock_add_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <form @submit.prevent="updateStock" style="padding:15px;">
            <div class="form-group">
              <label for="model">Model *</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.model.$invalid && submit,
                  'is-valid': !$v.stockItem.model.$invalid && submit
                }"
                type="text"
                v-model="stockItem.model"
                class="form-control"
                id="model"
                name="model"
                aria-describedby="model_help"
                placeholder="Model i.e:IM20-18"
              />
              <div class="invalid-feedback">Please provide a Model Number</div>
            </div>

            <div class="form-group">
              <label for="qty">qty *</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.qty.$invalid && submit,
                  'is-valid': !$v.stockItem.qty.$invalid && submit
                }"
                type="text"
                v-model="stockItem.qty"
                class="form-control"
                id="qty"
                name="qty"
                aria-describedby="qty_help"
                placeholder="qty i.e:99"
              />
              <div class="invalid-feedback" v-if="!$v.stockItem.qty.required">
                Please provide a qty
              </div>
              <div class="invalid-feedback" v-if="!$v.stockItem.qty.numeric">
                Only numbers allowed
              </div>
            </div>

            <div class="form-group">
              <label for="name">Name *</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.productName.$invalid && submit,
                  'is-valid': !$v.stockItem.productName.$invalid && submit
                }"
                type="text"
                v-model="stockItem.productName"
                class="form-control"
                id="name"
                name="name"
                aria-describedby="model_help"
                placeholder="Name i.e:Noopept"
              />
              <div class="invalid-feedback">Please provide a name</div>
            </div>

            <div class="form-group">
              <label for="ingredients">Ingredients *</label>
              <textarea
                rows="7"
                cols="50"
                :class="{
                  'is-invalid': $v.stockItem.ingredients.$invalid && submit,
                  'is-valid': !$v.stockItem.ingredients.$invalid && submit
                }"
                v-model="stockItem.ingredients"
                class="form-control"
                id="ingredients"
                name="ingredients"
                aria-describedby="ingredients_help"
                placeholder="Ingredients i.e: pramiracetam, microcrystalline cellulose"
              ></textarea>
              <div class="invalid-feedback">Please provide ingredients</div>
            </div>

            <div class="form-group">
              <label for="stockable">stockable *</label>
              <select
                :class="{
                  'is-invalid': $v.stockItem.stockable.$invalid && submit,
                  'is-valid': !$v.stockItem.stockable.$invalid && submit
                }"
                v-model="stockItem.stockable"
                class="form-control"
                id="stockable"
                name="stockable"
              >
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </div>

            <div class="form-group">
              <label for="length">Length</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.length.$invalid && submit,
                  'is-valid': !$v.stockItem.length.$invalid && submit
                }"
                type="text"
                v-model="stockItem.length"
                class="form-control"
                id="length"
                name="length"
                placeholder="length in cm"
              />
              <div class="invalid-feedback">Please provide a length</div>
            </div>

            <div class="form-group">
              <label for="width">Width</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.width.$invalid && submit,
                  'is-valid': !$v.stockItem.width.$invalid && submit
                }"
                type="text"
                v-model="stockItem.width"
                class="form-control"
                id="width"
                name="width"
                placeholder="width in cm"
              />
              <div class="invalid-feedback">Please provide a width</div>
            </div>

            <div class="form-group">
              <label for="height">Height</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.height.$invalid && submit,
                  'is-valid': !$v.stockItem.height.$invalid && submit
                }"
                type="text"
                v-model="stockItem.height"
                class="form-control"
                id="height"
                name="height"
                placeholder="height in cm"
              />
              <div class="invalid-feedback">Please provide a height</div>
            </div>

            <div class="form-group">
              <label for="weight">Weight</label>
              <input
                :class="{
                  'is-invalid': $v.stockItem.weight.$invalid && submit,
                  'is-valid': !$v.stockItem.weight.$invalid && submit
                }"
                type="text"
                v-model="stockItem.weight"
                class="form-control"
                id="weight"
                name="weight"
                placeholder="weight in grams"
              />
              <div class="invalid-feedback">Please provide a weight</div>
            </div>

            <div class="form-group">
              <label>Expiry Date</label>
              <br />
              <div
                :class="{
                  'is-invalid': $v.stockItem.expiryDate.$invalid && submit,
                  'is-valid': !$v.stockItem.expiryDate.$invalid && submit
                }"
              >
                <date-picker
                  input-class="form-control"
                  @change="setExpiryDate"
                  @clear="setExpiryDate"
                  :value="stockItem.expiryDate"
                  input-name="shipping_date"
                  :first-day-of-week="1"
                  lang="en"
                  type="month"
                  format="YYYY-MM"
                ></date-picker>
                <div
                  class="invalid-feedback"
                  v-if="!$v.stockItem.expiryDate.required"
                >
                  Please provide a shipping date
                </div>
              </div>
            </div>

            <b-btn variant="success" size="md" class="float-left" type="submit"
              >Update</b-btn
            >
            <b-btn
              variant="secondary"
              size="md"
              class="float-right"
              :to="'/stock/'"
              >Cancel</b-btn
            >
            <br />
            <br />
            <br />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric, integer } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import format from "date-fns/format";
export default {
  name: "shopify-stock-edit",
  components: {
    DatePicker
  },
  mounted() {
    this.getStockItem();
  },
  data() {
    return {
      stockItem: {
        model: "",
        qty: "",
        productName: "",
        ingredients: "",
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        stockable: "yes",
        expiryDate: null
      },
      submit: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Stock", to: { name: "stock" } },
        { text: "Edit", active: true }
      ]
    };
  },
  validations() {
    return {
      stockItem: {
        expiryDate: {},
        model: {
          required
        },
        qty: {
          required,
          numeric
        },
        productName: {
          required
        },
        ingredients: {
          required
        },
        stockable: {
          required
        },
        length: {
          numeric,
          integer
        },
        width: {
          numeric,
          integer
        },
        height: {
          numeric,
          integer
        },
        weight: {
          numeric,
          integer
        }
      }
    };
  },
  methods: {
    setExpiryDate(e) {
      this.stockItem.expiryDate = e ? format(e, "yyyy-MM") : null;
    },
    getStockItem() {
      let loader = this.$loading.show();
      this.$http
        .get(
          this.APIURL + this.BRAND + "/stock/" + this.$route.params.id + "/edit"
        )
        .then(
          response => {
            this.stockItem.model = response.data.model;
            this.stockItem.qty = response.data.quantity;
            this.stockItem.productName = response.data.name;
            this.stockItem.ingredients = response.data.ingredients;
            this.stockItem.length = response.data.length;
            this.stockItem.width = response.data.width;
            this.stockItem.height = response.data.height;
            this.stockItem.weight = response.data.weight;
            this.stockItem.stockable = response.data.stockable;
            this.stockItem.expiryDate = response.data.expiry_date;
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    updateStock() {
      this.submit = true;
      if (!this.$v.stockItem.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let formData = {
          model: this.stockItem.model,
          qty: this.stockItem.qty,
          name: this.stockItem.productName,
          length: this.stockItem.length,
          width: this.stockItem.width,
          height: this.stockItem.height,
          weight: this.stockItem.weight,
          ingredients: this.stockItem.ingredients,
          stockable: this.stockItem.stockable,
          expiryDate: this.stockItem.expiryDate
        };

        this.$http
          .put(
            this.APIURL + this.BRAND + "/stock/" + this.$route.params.id,
            formData
          )
          .then(
            () => {
              this.$swal({
                title: "Success!",
                showConfirmButton: false,
                timer: 1000,
                html:
                  "Operation completed successfully, taking you back to product list.",
                type: "success",
                onClose: () => {
                  loader.hide();
                  this.$router.push({ name: "stock" });
                }
              });
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }
};
</script>
